import { Modal, Button, Typography } from "antd";
import { useDispatch } from "react-redux";
import { setReduxDataTypeIntroTour } from "../Redux/futures/home/actions";
import { KEY_LOCAL_TOUR_COMPLETE, KEY_LOCAL_TYPE_USER } from "../helper/const";
import { useNavigate } from "react-router";
import PATH from "../config/PATH";
import { useTranslation } from "react-i18next";

export default function ModalNewBid({ dataApi, open, onClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { t } = useTranslation();
  const [line1, line2, line3, line4] = t('user_guide.you_have_placed_want_other_chances', {returnObjects: true});

  const handleBymoreTurn = () => {
    onClose();
    dispatch(
      setReduxDataTypeIntroTour({
        typeActive: 0,
        step: -1,
      })
    );
    localStorage.removeItem(KEY_LOCAL_TYPE_USER);
    // localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
    navigate(PATH.PACKAGE)
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable
      centered
      className="custom-success-modal"
    >
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <h2 style={{ fontWeight: "500", fontSize: "24px" }}>{t("user_guide.successful")}</h2>
      </div>

      <div
        style={{
          backgroundColor: "#f9f9fc",
          borderRadius: 12,
          padding: 16,
          fontSize: 15,
        }}
      >
        <div>
          {dataApi?.errorMessage
            ? dataApi.errorMessage
            : dataApi?.data?.content}
        </div>
        <div>
          {line2}
          <br />
          {line3}
          <br />
          {line4}
        </div>
      </div>

      <div style={{ marginTop: 24, textAlign: "center" }}>
        <Button
          type="primary"
          size="large"
          className="scale-hover-item"
          style={{
            backgroundColor: "rgba(249, 122, 28, 1)",
            border: "none",
            borderRadius: 24,
            padding: "0 32px",
          }}
          onClick={handleBymoreTurn}
        >
          {t('bid_page.buy_more_turns')}
        </Button>
      </div>
    </Modal>
  );
}
